import React from "react";
import PropTypes from "prop-types";
import BuildingIcon from "./BuildingIcon";
import styles from "./styles.module.scss";

const NarrowSearchBanner = ({ listingCount }) => (
  <section className={styles.narrowSearchBanner}>
    <div className={styles.iconAndTitleContainer}>
      <BuildingIcon className={styles.icon} />

      <h2 className={styles.title}>
        There are {listingCount} more listings matching your search criteria.
        Adjust your filters above to narrow down your results.
      </h2>
    </div>
  </section>
);

NarrowSearchBanner.propTypes = {
  listingCount: PropTypes.number.isRequired,
};

export default NarrowSearchBanner;
